import { CUSTOM_ELEMENTS_SCHEMA, Component, EnvironmentInjector, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IonApp, IonRouterOutlet, IonTabs, IonSplitPane } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { register } from 'swiper/element/bundle';
import { ThemeService } from './shared/services/theme.service';
import { SafeAreaService } from './shared/services/safe-area.service';
import { BannerCookiesComponent } from './components/banner-cookies/banner-cookies.component';

register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    standalone: true,
    imports: [IonTabs, IonApp, IonRouterOutlet, IonSplitPane, BannerCookiesComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
    public team = environment.team;
    title = 'Portal do Aluno';
    public isDarkMode = false;

    constructor(
        public environmentInjector: EnvironmentInjector,
        private titleService: Title,
        private themeService: ThemeService,
        private safeAreaService: SafeAreaService,
    ) {}

    ngOnInit() {
        this.updateFavIconAndTitle();
        this.safeAreaService.init().catch(error => console.error('Erro ao aplicar safe area', error));
        this.themeService.darkMode$.subscribe(darkMode => {
            this.isDarkMode = darkMode;
            this.applyTheme();
        });
    }

    applyTheme() {
        const body = document.body;
        if (this.isDarkMode) {
            body.classList.add('dark');
        } else {
            body.classList.remove('dark');
        }
    }

    toggleDarkMode() {
        this.themeService.toggleDarkMode();
    }

    updateFavIconAndTitle() {
        const favIcon: HTMLLinkElement = document.querySelector('#appIcon') as HTMLLinkElement;
        if (!favIcon) return;

        switch (this.team) {
            case 'mairipora':
                favIcon.href = 'assets/img/favicon-mairipora/favicon.png';
                this.titleService.setTitle('Educa Sim');
                break;
            case 'francodarocha':
                favIcon.href = 'assets/img/favicon-franco/favicon.png';
                this.titleService.setTitle('Educa Franco');
                break;
            // case 'francodarocha':
            //     favIcon.href = 'assets/img/francodarocha/favicon.ico';
            //     this.titleService.setTitle('EducaFranco - Portal do Aluno');
            //     break;
            case 'nilopolis':
                favIcon.href = 'assets/img/favicon-nilopolis/favicon.png';
                this.titleService.setTitle('Nilópolis Educa');
                break;
            case 'guaratingueta':
                favIcon.href = 'assets/img/favicon-guara/favicon.png';
                this.titleService.setTitle('Escola Online');
                break;
            case 'itanhaem':
                favIcon.href = 'assets/img/favicon-itanhaem/favicon.png';
                this.titleService.setTitle('Educa Itanhaém');
                break;
            case 'ilhabela':
                favIcon.href = 'assets/img/favicon-ilhabela/favicon.png';
                this.titleService.setTitle('EducaFácil - Portal do Aluno');
                break;
            case 'cacapava':
                favIcon.href = 'assets/img/favicon-cacapava/favicon-cacapava.png';
                this.titleService.setTitle('Educa Caçapava - Portal do Aluno');
                break;
            case 'paraisopolis':
                favIcon.href = 'assets/img/favicon-paraisopolis/favicon.png';
                this.titleService.setTitle('Educa Paraisópolis - Portal do Aluno');
                break;

            default:
                favIcon.href = 'assets/img/favicon.png';
                this.titleService.setTitle('EducaFácil - Portal do Aluno');
                break;
        }
    }
}
